import {OrganizationBranchesAPI} from "./methods";
import {execute} from "../../apiCommandsExecutor";
import {ExecutionStatus} from "../general/requestsResponses";
import {
    CreateServiceOrderRequest,
    CreateServiceOrderResponse,
    GetOrganizationBranchRequest,
    GetOrganizationBranchResponse,
    GetServiceLegalDetailsRequest,
    GetServiceLegalDetailsResponse,
    OrganizationBranchesUpdateCompanyCardRequest,
    OrganizationBranchesUpdateCompanyCardResponse,
    OrganizationBranchesUpdateLegalDataRequest,
    OrganizationBranchesUpdateLegalDataResponse, ServiceOrdersCancelInvoiceOrderRequest,
    ServiceOrdersGetServiceOrdersRequest,
    ServiceOrdersGetServiceOrdersResponse,
    UpdateOrganizationBranchRequest,
    UpdateOrganizationBranchResponse
} from "./requestsResponses";

export const createServiceOrder = async (params: CreateServiceOrderRequest) => {
    const response = await execute<CreateServiceOrderRequest, CreateServiceOrderResponse>(
        OrganizationBranchesAPI.createServiceOrder, params);

    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        serviceOrder: response.data.serviceOrder,
        //@ts-ignore
        message: response.data.errorMessages
    }
}

export const getServiceLegalDetails = async (params: GetServiceLegalDetailsRequest) => {
    const response = await execute<GetServiceLegalDetailsRequest, GetServiceLegalDetailsResponse>(
        OrganizationBranchesAPI.getServicePaymentProviderDetails, params);

    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        paymentProviderDetails: response.data.paymentProvidersDetailsPublic
    }
}

export const getOrganisationBranch = async (params:  GetOrganizationBranchRequest) => {
    const response = await execute<GetOrganizationBranchRequest, GetOrganizationBranchResponse>(
        OrganizationBranchesAPI.getOrganizationBranch, params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        organizationBranch: response.data.organizationBranch
    }
};


export const updateOrganisationBranch = async (params:  UpdateOrganizationBranchRequest) => {
    const response = await execute<UpdateOrganizationBranchRequest, UpdateOrganizationBranchResponse>(
        OrganizationBranchesAPI.updateOrganizationBranch, params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
    }
};

export const updateCompanyCard = async (params: OrganizationBranchesUpdateCompanyCardRequest) => {
    const res = await execute<OrganizationBranchesUpdateCompanyCardRequest, OrganizationBranchesUpdateCompanyCardResponse>(
        OrganizationBranchesAPI.updateCompanyCard,
        params);
    return res.data;
};

export const updateLegalData = async (params: OrganizationBranchesUpdateLegalDataRequest) => {
    const res = await execute<OrganizationBranchesUpdateLegalDataRequest, OrganizationBranchesUpdateLegalDataResponse>(
        "OrganizationBranches.UpdateLegalData",
        params);
    return res.data;
};

export const getServiceOrders = async () => {
    const res = await execute<ServiceOrdersGetServiceOrdersRequest, ServiceOrdersGetServiceOrdersResponse>(
        "ServiceOrders.GetServiceOrders",
        {}
    );

    return res.data
}

export const cancelInvoiceOrder = async (params: ServiceOrdersCancelInvoiceOrderRequest) => {
    const res = await execute<ServiceOrdersGetServiceOrdersRequest, ServiceOrdersGetServiceOrdersResponse>(
        "ServiceOrders.CancelInvoiceOrder",
        params
    );

    return res.data
}